import { isMainnet } from "@/env";

export type CctpNetwork = "mainnet" | "testnet";

// Unlike v1, which always reads mainnet, v2 follows the app's network.
export const appCctpNetwork = (): CctpNetwork => (isMainnet ? "mainnet" : "testnet");

// v2 deploys each EVM contract at one address on every chain, different between mainnet and testnet.
export const EVM_TOKEN_MESSENGER_V2: Record<CctpNetwork, string> = {
  mainnet: "0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d",
  testnet: "0x8FE6B999Dc680CcFDD5Bf7EB0974218be2542DAA",
};

export const EVM_MESSAGE_TRANSMITTER_V2: Record<CctpNetwork, string> = {
  mainnet: "0x81D40F21F12A8F0E3252Bccb954D722d4c464B64",
  testnet: "0xE737e5cEBEEBa77EFE34D4aa090756590b1CE275",
};

export const APTOS_MESSAGE_TRANSMITTER_V2: Record<CctpNetwork, string> = {
  mainnet: "0x1b3f6d749cb835451202f9a1932e49014266f7e3d51611a9a763d156cb4bdaf6",
  testnet: "0xa582dc019ae17b0485f7d3fcc4ca85bea7941e3b70a4b682cea22759f36e711f",
};

// Same program ID on mainnet and devnet.
export const SOLANA_MESSAGE_TRANSMITTER_V2 = "CCTPV2Sm4AdWt5296sk4P66VBZ7bEhcARwFaaS9YPbeC";

export const SOLANA_USDC_MINT: Record<CctpNetwork, string> = {
  mainnet: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  testnet: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
};

/**
 * Our address lookup table holding the fixed accounts of a v2 claim on Solana, without which the
 * claim is too large to send. Create it with `scripts/create-solana-claim-lookup-table.ts`. Null
 * until created on that network; withdrawals to Solana stay on v1 there.
 */
export const SOLANA_CLAIM_LOOKUP_TABLE: Record<CctpNetwork, string | null> = {
  mainnet: "FVLkkfzPK2LtiVrEKqDgyx457ospMbz43woaD4QhNprx",
  testnet: "Hum9S9z4FPFroYqqtFJMoki9BRpjpV9y6PEc6JdXhfPm",
};

/**
 * The `decibel_cctp` package (`move/cctp`), which wraps Circle's Aptos v2 scripts as entry functions
 * the gas station can sponsor. Null until published on that network; burns stay on v1 there.
 */
export const DECIBEL_CCTP_WRAPPER: Record<CctpNetwork, string | null> = {
  mainnet: "0x7c7496156f669163ed6862d9a1c420ede4741b7f9534de1b70cc9cd6eef1c3ba",
  testnet: "0x8b2bca8852f0934d6fb144f9e7308edaaec93544516620c4a4d2d59d936bec2d",
};
